module.exports = __webpack_public_path__ + "static/avatar_mihail_bashtakov@2x-536fac6057ec10ed4490ef1914818a97.jpg";